// extracted by mini-css-extract-plugin
export var attribution = "HalfAndHalfContent-module--attribution--41341";
export var attributionImage = "HalfAndHalfContent-module--attribution-image--da499";
export var bgBlack = "HalfAndHalfContent-module--bg-black--0d744";
export var bgBlue = "HalfAndHalfContent-module--bg-blue--8f55b";
export var bgDarkPurple = "HalfAndHalfContent-module--bg-dark-purple--45d00";
export var bgGreen = "HalfAndHalfContent-module--bg-green--ebe05";
export var bgLightBlue = "HalfAndHalfContent-module--bg-light-blue--02196";
export var bgPink = "HalfAndHalfContent-module--bg-pink--ca146";
export var bgPurple = "HalfAndHalfContent-module--bg-purple--aa871";
export var bgWhite = "HalfAndHalfContent-module--bg-white--34856";
export var company = "HalfAndHalfContent-module--company--96c04";
export var container = "HalfAndHalfContent-module--container--1862c";
export var copy = "HalfAndHalfContent-module--copy--1737f";
export var copyContainer = "HalfAndHalfContent-module--copy-container--3fda8";
export var copyImage = "HalfAndHalfContent-module--copy-image--fad99";
export var cta = "HalfAndHalfContent-module--cta--2255c";
export var ctaImage = "HalfAndHalfContent-module--cta-image--1e0fe";
export var extended = "HalfAndHalfContent-module--extended--8257a";
export var gradientBackground = "HalfAndHalfContent-module--gradient-background--908de";
export var iconList = "HalfAndHalfContent-module--icon-list--75b25";
export var leftSide = "HalfAndHalfContent-module--left-side--0319b";
export var paragraph = "HalfAndHalfContent-module--paragraph--2be6c";
export var person = "HalfAndHalfContent-module--person--90bf8";
export var quote = "HalfAndHalfContent-module--quote--8fdd0";
export var spacer = "HalfAndHalfContent-module--spacer--f6434";
export var testimonialHeading = "HalfAndHalfContent-module--testimonial-heading--47c34";